import { COARSE, MIN_TARGET_PX } from '../../../root/touchTheme';

export const TOOLBAR_HEIGHT = 26;

// A touch screen makes every button 44 px (theme rule) and a toggle group
// grows with its buttons (theme rule). The controls that have their own fixed
// height follow, so a toolbar row is one height and nothing spills out of or
// sits small next to its neighbours.
export const toolbarToggleSx = {
    height: TOOLBAR_HEIGHT,
    '& .MuiToggleButton-root': {
        py: '2px',
        px: 1,
        fontSize: '11px',
        fontWeight: 600,
        textTransform: 'none' as const,
        borderColor: 'divider',
    },
};

export const toolbarSelectSx = {
    height: TOOLBAR_HEIGHT,
    [COARSE]: { height: MIN_TARGET_PX },
    fontSize: '11px',
    fontWeight: 600,
    '& .MuiSelect-select': { py: '2px', px: 1 },
    '& .MuiOutlinedInput-notchedOutline': {
        borderColor: 'divider',
    },
};

// The theme gives an IconButton a 44 px minimum on a touch screen, which
// beats the 26 px below; the size is stated here for the row's sake.
export const toolbarIconButtonSx = {
    width: TOOLBAR_HEIGHT,
    height: TOOLBAR_HEIGHT,
    [COARSE]: { width: MIN_TARGET_PX, height: MIN_TARGET_PX },
    p: 0,
    flexShrink: 0,
    borderRadius: '4px',
    border: '1px solid',
    borderColor: 'divider',
};

export const toolbarButtonSx = {
    height: TOOLBAR_HEIGHT,
    minWidth: 0,
    px: 1.25,
    py: 0,
    fontSize: '11px',
    fontWeight: 600,
    textTransform: 'none' as const,
};
